import HeaderBlue from "../../components/HeaderBlue";
import FooterBlue from "../../components/FooterBlue";

const CookiePolicy = () => (
    <>
        <div
            className="relative h-[260px] md:h-[320px] w-full overflow-hidden"
            style={{
                backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url("/assets/policyheader.webp")`,
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}

        >
            <HeaderBlue />
        </div>


         <div className="bg-gray-50 min-h-screen pt-24 font-[Oswald] text-gray-900 leading-relaxed">
            <main className="max-w-6xl mx-auto p-6 md:p-12 bg-white rounded-xl shadow-lg ">

                <div className="relative z-10 -mt-32 md:-mt-48  mx-auto mb-12">
                    <div
                        className="relative z-10 -mt-32 md:-mt-40 text-white rounded-2xl shadow-md p-10 mb-12  mx-auto"
                        style={{ backgroundColor: '#3c9bf9' }}>
                    <h1 className="text-2xl md:text-5xl font-bold mb-3">Cookie Policy</h1>
                    <p className="text-gray-200">Effective Date: 08-19-2025</p>
                </div>
                </div>

                {/* Intro */}
                <section className="bg-white shadow-sm rounded-xl p-8 mb-10">
                    <p className="text-lg text-gray-700 leading-relaxed">
                        This Cookie Policy explains how{" "}
                        <span className="">Fleety LLC</span> (“Fleety,” “we,”
                        “our,” or “us”) uses cookies and similar tracking technologies when
                        you visit or use our websites, applications, or related online
                        services (the “Services”).
                        <br />
                        By continuing to browse or use the Services, you consent to the use
                        of cookies as described in this policy.
                    </p>
                </section>

                <div className="space-y-10">
                    <section className="bg-white p-4 rounded-xl shadow-sm">
                        <h2 className="text-2xl   mb-4">
                            1. What Are Cookies?
                        </h2>
                        <p className="text-gray-700 text-lg">
                            Cookies are small text files placed on your device when you access
                            a website or service. They allow us to recognize your browser,
                            store preferences, and improve your overall user experience.
                            Cookies may be set directly by us (first-party cookies) or by
                            third parties (third-party cookies).
                        </p>
                    </section>

                    <section className="bg-white p-4 rounded-xl shadow-sm">
                        <h2 className="text-2xl   mb-6">
                            2. Types of Cookies We Use
                        </h2>
                        <div className="space-y-6 text-lg text-gray-700">
                            <div>
                                <h3 >1. Strictly Necessary Cookies</h3>
                                <ul className="list-disc ml-6 mt-2 space-y-1">
                                    <li>Essential for the operation of the Services.</li>
                                    <li>Enable secure login and account access.</li>
                                </ul>
                            </div>
                            <div>
                                <h3 >2. Performance and Analytics Cookies</h3>
                                <ul className="list-disc ml-6 mt-2 space-y-1">
                                    <li>Track how users interact with the Services.</li>
                                    <li>Help us improve design, speed, and functionality.</li>
                                </ul>
                            </div>
                            <div>
                                <h3 >3. Functional Cookies</h3>
                                <ul className="list-disc ml-6 mt-2 space-y-1">
                                    <li>Save preferences such as language and time zone.</li>
                                    <li>Provide a more personalized experience.</li>
                                </ul>
                            </div>
                            <div>
                                <h3 >4. Advertising and Targeting Cookies</h3>
                                <ul className="list-disc ml-6 mt-2 space-y-1">
                                    <li>Deliver relevant ads and measure campaign success.</li>
                                    <li>May be set by Fleety or advertising partners.</li>
                                </ul>
                            </div>
                            <div>
                                <h3 >5. Third-Party Cookies</h3>
                                <ul className="list-disc ml-6 mt-2 space-y-1">
                                    <li>
                                        Set by analytics providers (e.g., Google Analytics) or
                                        advertisers.
                                    </li>
                                    <li>Track your activity across multiple services.</li>
                                </ul>
                            </div>
                        </div>
                    </section>

                    <section className="bg-white p-4 rounded-xl shadow-sm">
                        <h2 className="text-2xl   mb-4">
                            3. How We Use Cookies
                        </h2>
                        <ul className="list-disc ml-6 text-lg text-gray-700 space-y-1">
                            <li>Provide and secure the Services.</li>
                            <li>Measure performance and trends.</li>
                            <li>Save preferences and customize content.</li>
                            <li>Support advertising and campaigns.</li>
                            <li>Analyze traffic and improve Services.</li>
                        </ul>
                    </section>

                    <section className="bg-white p-4 rounded-xl shadow-sm">
                        <h2 className="text-2xl   mb-4">
                            4. How to Control Cookies
                        </h2>
                        <ul className="list-disc ml-6 text-lg text-gray-700 space-y-2">
                            <li>Manage cookies in your browser settings.</li>
                            <li>
                                Disabling cookies may limit full use of our Services.
                            </li>
                            <li>
                                Learn more at{" "}
                                <a
                                    href="https://www.allaboutcookies.org"
                                    className="text-blue-600 underline"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    www.allaboutcookies.org
                                </a>
                            </li>
                            <li>
                                Some third-party services (like Google Analytics) have their own
                                opt-out tools.
                            </li>
                        </ul>
                    </section>

                    <section className="bg-white p-4 rounded-xl shadow-sm">
                        <h2 className="text-2xl   mb-4">
                            5. Do Not Track
                        </h2>
                        <p className="text-lg text-gray-700">
                            Our Services do not currently respond to “Do Not Track” signals
                            from browsers. However, you may limit tracking by adjusting your
                            cookie settings as described above.
                        </p>
                    </section>

                    <section className="bg-white p-4 rounded-xl shadow-sm">
                        <h2 className="text-2xl   mb-4">
                            6. Updates to This Cookie Policy
                        </h2>
                        <p className="text-lg text-gray-700">
                            We may update this Cookie Policy to reflect changes in practices
                            or laws. The “Effective Date” will always show the latest update.
                            Please check this page periodically.
                        </p>
                    </section>

                    <section className="bg-white p-4 rounded-xl shadow-sm">
                        <h2 className="text-2xl   mb-4">
                            7. Contact Us
                        </h2>
                        <p className="text-lg text-gray-700">
                            Questions about this Cookie Policy? Contact us at:
                            <br />
                            Fleety LLC
                            <br />
                            <a
                                href="mailto:support@fleetycdl.com"
                                className="text-blue-600 underline"
                            >
                                support@fleetycdl.com
                            </a>
                        </p>
                    </section>
                </div>
            </main>
        </div>
        <FooterBlue />
    </>
);

export default CookiePolicy;
